class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.headerWrapper = document.querySelector('sticky-header');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.headerWrapper.classList.remove('bg-white');
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.headerWrapper.classList.add('bg-white');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerContainer = document.querySelector('.section-header');

    // Añadir eventos a los hermanos
    this.mainDetailsToggle.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.mainDetailsToggle.addEventListener('mouseout', this.onMouseOut.bind(this));
    this.content.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.content.addEventListener('mouseout', this.onMouseOut.bind(this));
  }

  onMouseOver(event) {
    clearTimeout(this.closeTimeout); // Cancelar el cierre pendiente
    setTimeout(() => {
      if (this.header.classList.contains('header--transparent')) {
        this.headerContainer.classList.add('scrolled-past-header');
      }
      this.open();
    }, 300);

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseOut(event) {
    const relatedTarget = event.relatedTarget;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (relatedTarget && (this.mainDetailsToggle.contains(relatedTarget) || this.content.contains(relatedTarget))) {
      return;
    }

    this.closeTimeout = setTimeout(() => {
      if (this.header.classList.contains('header--transparent') && scrollTop == 0) {
        this.headerContainer.classList.remove('scrolled-past-header');
      }
      this.close();
    }, 300); // Retraso para permitir el hover entre elementos
  }

  // onToggle() {
  //   if (!this.headerContainer) return;

  //   console.log('evnet', event)

  //   if (!this.mainDetailsToggle.hasAttribute('open')) {
  //     if (!this.headerContainer.classList.contains('scrolled-past-header')) {
  //       this.headerWrapper.classList.add('bg-transparent');
  //     }
  //     this.headerWrapper.classList.remove('bg-white');
  //   } else {
  //     this.headerWrapper.classList.remove('bg-transparent');
  //     this.headerWrapper.classList.add('bg-white');
  //   }

  //   if (!this.header) return;
  //   this.header.preventHide = this.mainDetailsToggle.open;
  //   if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
  //   document.documentElement.style.setProperty(
  //     '--header-bottom-position-desktop',
  //     `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
  //   );
  // }
}

customElements.define('header-menu', HeaderMenu);
